import { Component, OnInit} from '@angular/core';
// import { AlertService } from '../../shared';
// import { EventService } from '../../shared/event/event.service';
// import { CognitoAuthService } from '../../shared/auth/cognito.service';
// declare const moment: any;

@Component({
    selector: 'alerts',
    templateUrl: './alerts.component.html',
    styleUrls: ['./alerts.component.css'],
    // providers: [EventService]
    providers: [ ]
})

export class AlertsComponent implements OnInit {

    // Default alertTimePeriod is ALL
    alertTimePeriod = 'a';
    showRanges = true;

    /*
    isAlertsDataLoading = true;
    isAlertsDataError = false;
    maxAlertDataCallRetries = 3;
    alertsDataSubscription;

    alerts = [];
    */

    // constructor(private alertService: AlertService, private eventService: EventService, private authService: CognitoAuthService) { }
    constructor() { }

    ngOnInit() {

        // this.getAlerts();
    }

    getAlerts() {

        /*
        const self = this;

        this.authService.getIdToken({
            callback() {},
            callbackWithParam(idToken:any) {
                var customer = self.authService.decodeToken(idToken)["custom:customer"];
                self.alertsDataSubscription = self.alertService.getAlerts(idToken, customer).subscribe(function(alerts) {
                    var allEventIds = '';

                    // Adjust the Date field a bit in the Alerts list
                    var adjAlerts = alerts.map(function(alert) {
                        alert.date = alert.date.substring(0, 19).replace('T', ' ');
                        alert.event_count = (alert.event_ids) ? 1 + (alert.event_ids.match(/,/g) || []).length : 0;
                        allEventIds += alert.event_ids ? (allEventIds ? ',' : '') + alert.event_ids : '';
                    });
                    self.alerts = alerts;
                    self.isAlertsDataLoading = false;
                    self.isAlertsDataError = false;

                    // we got the Alerts, now initiate the Events get as well immediately
                    // self.getEvents(allEventIds);

                }, function(err) {

                    console.log('Error in getAlerts() of dashboard.component');

                    self.alerts = [ ];
                    self.isAlertsDataLoading = false;
                    self.isAlertsDataError = true;

                    self.alertsDataSubscription.unsubscribe();
                    --self.maxAlertDataCallRetries;
                    if(self.maxAlertDataCallRetries > 0){
                        self.getAlerts();
                    }
                });
            }
        });
        */
    }
}



// WEBPACK FOOTER //
// /app/src/app/containers/alerts/alerts.component.ts